export default "__VITE_PUBLIC_ASSET__bc75e1d0__"